import axios from 'axios'
axios.defaults.baseURL = 'http://111.229.214.104:8000'


const state = {
bookIntroduce:[],
detailsList:[],
detailsName:[],
detailsImage:[]
}

const mutations = {
GET_DETAILS(state,data) {
  state.bookIntroduce = data
},
GET_DETAILS_LIST(state,data) {
  state.detailsList = data
},
GET_DETAILS_IMAGE (state,data) {
  state.detailsImage = data
},
GET_DETAILS_NAME (state, data) {
  state.detailsName = data
}
}

const actions = {
  // 获取详情也的信息
	getDetails ({ commit },data) {
    //
    // console.log(data)
    // console.log(this.$cookie.get('token'))
    if(data.token === null) {
      data.token = ''
    }else {
      data.token
    }
    // console.log(data.token)
		return axios.get('/book/?id='+ data.id + "&token=" + data.token ).then((response) => {
      // console.log(response)
			commit('GET_DETAILS',response.data.context.book_introduce)
      commit('GET_DETAILS_IMAGE',response.data.context.books_imageaddress)
      commit('GET_DETAILS_NAME',response.data.context.book_name)
      commit('GET_DETAILS_LIST',response.data.context.video_list)
      // console.log(response.data.context.book_name)
      return response
		})
	},
  // getDetailogn(datas) {
  //   console.log(datas)
  //   // console.log(commit)
  //   return axios.get('/book/video/?id='+ datas.id +'&&points=' + datas.points)
  // }
  // 点击到付费
  getFu({ commit },data) {
    commit("GET_FU")
    // console.log(data)
    return axios.get('/book/video/?id=' + data.id + '&points=' + data.points  +'&token=' + data.token).then((res) => {
     return res
    })
  }
}

const getters = {
//   nide(state) {
//     // let data = state.detailsList
// console.log(state.detailsList)

//   }
}

const DetailsModule = {
  state,
  mutations,
  actions,
  getters
}

export default DetailsModule
